export default __webpack_public_path__ + "static/media/Info-green.f805728d.svg";